/**
 * Build report filename prefix from evaluation (product name + version).
 * Ported from GSA openacr-editor src/utils/reportFilename.js
 * @param {object} evaluation - Evaluation state
 * @param {boolean} [includeReportVersion=true] - Whether to append report version
 * @returns {string}
 */
export default function reportFilename(evaluation, includeReportVersion = true) {
  let name = "report";
  if (evaluation?.product?.name) {
    name = evaluation.product.name.toLowerCase();
  }
  if (evaluation?.product?.version) {
    name += `-${evaluation.product.version}`;
  }
  if (includeReportVersion && evaluation?.version != null && evaluation?.version !== "") {
    name += `-${evaluation.version}`;
  }
  return name;
}
